import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=67174163&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=ts&"
export * from "./uploader.vue?vue&type=script&lang=ts&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=67174163&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67174163",
  null
  
)

export default component.exports